import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { EnvironmentService } from 'src/app/core/environment.service';
import { TranslateModule } from '@ngx-translate/core';
import { RCFooterModule, RCScrollButtonModule, RCIconModule } from '@rc/ui';

@Component({
  selector: 'app-rc-footer',
  templateUrl: './rc-footer.component.html',
  styleUrls: ['./rc-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RCFooterModule,
    RCScrollButtonModule,
    RCIconModule,
    TranslateModule,
  ],
})
export class RcFooterComponent {
  env = inject(EnvironmentService);

  @Input() version = '';
}
